import ActivitySummaryModule from './containers/activitySummaryModule'

export {default as ActivitySummaryModuleLayout} from './components/activitySummaryModuleLayout'

export default ActivitySummaryModule
